var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollRef"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require('@/assets/img/knowledge/banner.png'),"alt":"","data-aos":"zoom-out"}}),_c('router-view',{on:{"knowledgeSelect":_vm.knowledgeSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }